import logo from './logo.svg';
import './App.css';
import NavbarComponent from './Component/NavbarComponent';
import Footer from './Component/Footer';
import Home from './Component/Home';
import {HashRouter, Route, Routes } from 'react-router-dom';
import Aboutus from './Component/Aboutus';
import Vendor from './Component/Vendor';
import Budget from './Component/Budget';
import Advertisement from './Component/Advertisement';
import Administration from './Component/Administration';
import Contactus from './Component/Contactus';
import Restaurant from './Component/Restaurant';
import Immigration from './Component/Immigration';
import MarketingBranding from './Component/MarketingBranding';
import Import from './Component/Import';
import CustomProd from './Component/CustomProd';

function App() {
  return (
    <>
   
      <NavbarComponent />
     <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/aboutus' element={<Aboutus/>}/>
      <Route path='/vendor-management' element={<Vendor/>}/>
      <Route path='/budgeting-overseeing' element={<Budget/>}/>
      <Route path='/advertisementplan-strategies' element={<Advertisement/>}/>
      <Route path='/administration-staffing' element={<Administration/>}/>
      <Route path='/restaurant-management' element={<Restaurant/>}/>
      <Route path='/immigration-services' element={<Immigration/>}/>
      <Route path='/contactus' element={<Contactus/>}/>
      <Route path='/marketing-branding' element={<MarketingBranding/>}/>
      <Route path='/import-distribution-delivery' element={<Import/>}/>
      <Route path='/label-printing-packaging-services' element={<CustomProd/>}/>

     </Routes>
      {/* <Country/>
      <Team/> */}
   
      <Footer/>
    </>
  )
}
export default App;
